import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  constructor(protected router: Router) {}
  event(
    action: string,
    category: string = null,
    label: string = null,
    value: string = null
  ) {
    if (!window['gtag']) {
      return;
    }
    try {
      window['gtag']('event', action, {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        event_category: category,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        event_label: label,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        value,
      });
    } catch (error) {}
  }

  pageView(page: string) {
    if (!window['gtag']) {
      return;
    }
    try {
      window['gtag']('config', 'UA-154002031-1', {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        page_title: page,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        page_path: this.router.url || null,
      });
    } catch (error) {}
  }
}
